import React from "react";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import module_style from "./Style.module.css";
import MoreVert from "@material-ui/icons/MoreVert";

export const MoreActions = ({ options, shift = { x: 80, y: 70 } }) => {
  const [show_more_modal, set_show_more_modal] = React.useState(false);
  const [modal_coordinates, set_modal_coordinates] = React.useState({
    x: 0,
    y: 0,
  });

  const handleClick = (e) => {
    set_modal_coordinates({ x: e.clientX, y: e.clientY });
    set_show_more_modal(true);
  };

  return (
    <>
      <MoreVert onClick={handleClick} className="pointer" />

      {show_more_modal && (
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          open={show_more_modal}
          onClose={() => {
            set_show_more_modal(false);
          }}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <div
            style={{
              left:
                modal_coordinates.x > 0 ? modal_coordinates.x - shift.x : "",
              top: modal_coordinates.y > 0 ? modal_coordinates.y + shift.y : "",
            }}
            className={`${module_style.week_modal} ${module_style.options_modal}`}
          >
            {options.map((item) => (
              <div
                className={module_style.item}
                onClick={() => {
                  set_show_more_modal(false);
                  item.handleClick();
                }}
                key={item.title}
              >
                {item.icon && item.icon} {item.title}
              </div>
            ))}
          </div>
        </Modal>
      )}
    </>
  );
};
